import CoreAPI from '../Core/CoreAPI';
import axios from 'axios';
export class EnvironmentsService {
  constructor() {
    this.setApi(new CoreAPI(process.env.REACT_APP_BASE_BFF));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL)
      this.setApi(new CoreAPI(process.env.REACT_APP_BASE_BFF));

    return this.api;
  }

  async getEnvironments() {
    const isQuality = process.env.REACT_APP_ENVIRONMENT === 'quality';

    const { data } = await this.getAPI()
      .getInstance()
      .get(
        `environments/${process.env.REACT_APP_PROJECT_NAME}/${process.env.REACT_APP_ENVIRONMENT}${
          isQuality ? `?squad=${process.env.REACT_APP_SQUAD}` : ''
        }`
      );

    const environments = JSON.parse(sessionStorage.getItem('environments'));
    if (!environments) {
      sessionStorage.setItem('environments', JSON.stringify(data));
      return;
    }
    sessionStorage.setItem(
      'environments',
      JSON.stringify({ ...data, ...environments })
    );
  }

  async getSuperUserEnvironments(superUserAccessToken) {
    const isQuality = process.env.REACT_APP_ENVIRONMENT === 'quality';

    const { data } = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_BASE_BFF}environments/${
        process.env.REACT_APP_PROJECT_NAME
      }/${process.env.REACT_APP_ENVIRONMENT}/superuser${
        isQuality ? `?squad=${process.env.REACT_APP_SQUAD}` : ''
      }`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'app-version': process.env.REACT_APP_VERSION,
        Authorization: `bearer ${superUserAccessToken}`
      }
    });

    const environments = JSON.parse(sessionStorage.getItem('environments'));
    if (!environments) {
      sessionStorage.setItem('environments', JSON.stringify(data));
      return;
    }

    sessionStorage.setItem(
      'environments',
      JSON.stringify({ ...data, ...environments })
    );
  }
}

export const getSessionItem = varSessionItem => {
  let urlEnviroment = JSON.parse(sessionStorage.getItem('environments'));
  return (urlEnviroment && urlEnviroment[varSessionItem]) || '';
};
